import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocomplete, MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {MatChipList} from '@angular/material/chips';
import {ConstantsService} from '@app/services/constants/constants.service';
import {Globals} from "@app/services/globals.service";

@Component({
    selector: 'app-choose-assigned-users',
    templateUrl: './choose-assigned-users.component.html',
    styleUrls: ['./choose-assigned-users.component.css']
})
export class ChooseAssignedUsersComponent implements OnInit {
    @Input() myForm: FormGroup;
    @Input() ids: number[];

    @Output() outputToParent = new EventEmitter<number[]>();

    @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;
    @ViewChild('chipList') chipList: MatChipList;

    constructor(public proventumApiService: ProventumApiService,
                public taskService: TaskService,
                private fb: FormBuilder,
                private contantsService: ConstantsService,
                private globalsService: Globals) {
    }


    selectable = true;
    removable = true;

    separatorKeysCodes: number[] = [ENTER, COMMA];
    users = [];
    assignedTags = [];

    searchText = '';
    search = new FormControl();


    ngOnInit(): void {
        this.users = this.globalsService.getAllActiveUsers().map(value => {
            const item = {
                id: value.id,
                full_name: value['first_name'] + ' ' + value['last_name'],
                avatar: value.avatar
            };
            return item;
        });

        if (this.ids.length > 0) {
            this.ids.forEach(item => {
                let data = this.users.find(x => x.id === item);
                if (data) {
                    this.assignedTags.push(data);
                }
            });
            const ids = this.assignedTags.map(item => item.id);
            this.myForm.patchValue({assigned: ids});
        }
    }

    remove(tag): void {
        this.assignedTags = this.assignedTags.filter(item => item.id !== tag.id);
        let ids = this.assignedTags.map(item => {
            return item.id
        });
        this.outputToParent.emit(ids);
    }


    selected(event: MatAutocompleteSelectedEvent): void {
        this.assignedTags.push(event.option.value);
        let ids = this.assignedTags.map(item => {
            return item.id
        });
        this.outputToParent.emit(ids);
        this.searchText = '';
        this.tagInput.nativeElement.value = '';
    }


}
